import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const images = () => {
  const images = document.querySelectorAll(".image");

  for (const image of images) {
    let swiper;
    const openTrigger = image.querySelector(".image-open");
    if (!openTrigger) {
      continue;
    }

    const section = image.closest(".section-inner");

    openTrigger.addEventListener("click", (e) => {
      const imageZoomItems = image.querySelectorAll(".image-zoom img");

      for (const item of imageZoomItems) {
        item.setAttribute("src", item.getAttribute("data-src"));
      }

      section.classList.add("has-lightbox");
      image.classList.add("is-open");
      document.body.style.overflow = "hidden";

      if (imageZoomItems.length > 1) {
        const swiperContainer = image.querySelector(".swiper");
        swiper = new Swiper(swiperContainer, {
          modules: [Navigation],
          navigation: {
            nextEl: image.querySelector(".image-zoom-next"),
            prevEl: image.querySelector(".image-zoom-prev"),
          },
        });
      } else {
        image.querySelector(".image-zoom-next").style.display = "none";
        image.querySelector(".image-zoom-prev").style.display = "none";
      }
    });

    const closeTriggers = image.querySelectorAll(
      ".image-zoom-overlay, .image-zoom-close"
    );

    for (const closeTrigger of closeTriggers) {
      closeTrigger.addEventListener("click", (e) => {
        image.classList.remove("is-open");
        document.body.style.overflow = "auto";
        setTimeout(() => {
          swiper.destroy();
          section.classList.remove("has-lightbox");
        }, 300);
      });
    }
  }
};

export default images;
